import { render, staticRenderFns } from "./match-indicators.vue?vue&type=template&id=5b24a576"
import script from "./match-indicators.vue?vue&type=script&lang=js"
export * from "./match-indicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports